var CollectionView = require('views/base/collection-view');

var ChecklistView = CollectionView.extend({
  noWrap: true,
  autoRender: true,
  template: require('./templates/checklist'),
  listSelector: '.checklist-items',
  animationDuration: 0,
  initialize: function() {
    if(this.model.get('grouped_by_module')) {
      EF.modules.head().set('first', true);
      this.collection = EF.modules;
      this.model.set('modules', EF.modules);
    } else {
      //TODO: this doesn't looked at whether the user has checked off the items
      this.collection = new Chaplin.Collection(this.model.get('items'));
    }

    CollectionView.prototype.initialize.apply(this, arguments);
  },
  initItemView: function(model) {
    var ItemViewType;
    var options = {
      model: model
    };

    if(this.model.get('grouped_by_module')) {
      ItemViewType = require('./checklist-module-view');
      var checklistItems = _(this.model.get('items')).filter({ checked: true, module_key: model.get('key') });
      options.collection = new Chaplin.Collection(checklistItems.value());
    } else {
      ItemViewType = require('./checklist-item-view');
    }

    return new ItemViewType(options);
  },
  getTemplateData: Chaplin.View.prototype.getTemplateData
});

module.exports = ChecklistView;